import React, { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { QUICK_TICKERS } from "./helpers";

export const TickerPicker = ({ value, onChange, onSubmit }) => {
  const [draft, setDraft] = useState(value || "NVDA");
  useEffect(() => {
    if (value) setDraft(value);
  }, [value]);

  const submit = (e) => {
    e?.preventDefault?.();
    const sym = draft.trim().toUpperCase();
    if (sym) {
      onChange(sym);
      onSubmit?.(sym);
    }
  };

  return (
    <div
      className="rounded-xl border border-white/10 bg-[#070710] p-4 mb-6"
      data-testid="analysis-picker"
    >
      <form onSubmit={submit} className="flex items-center gap-2 mb-3">
        <Search className="w-4 h-4 text-white/40 shrink-0" />
        <input
          type="text"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          placeholder="Ticker (e.g. NVDA, SPY, BTC-USD)"
          autoComplete="off"
          spellCheck={false}
          data-testid="analysis-ticker-input"
          className="bg-transparent flex-1 outline-none text-[14px] uppercase tracking-wider num font-medium placeholder:text-white/30"
        />
        <button
          type="submit"
          data-testid="analysis-ticker-submit"
          className="text-[11px] uppercase tracking-[0.18em] px-3 py-1.5 rounded-md border border-[#3FE5DC]/40 text-[#3FE5DC] hover:bg-[#3FE5DC]/10 transition"
        >
          Analyze
        </button>
      </form>
      <div className="flex flex-wrap gap-1.5">
        {QUICK_TICKERS.map((sym) => (
          <button
            key={sym}
            type="button"
            onClick={() => {
              setDraft(sym);
              onChange(sym);
              onSubmit?.(sym);
            }}
            data-testid={`analysis-quick-${sym}`}
            className={
              "text-[10.5px] uppercase tracking-[0.12em] px-2 py-1 rounded-md border transition num " +
              (value === sym
                ? "border-[#3FE5DC]/55 bg-[#3FE5DC]/10 text-[#3FE5DC]"
                : "border-white/12 text-white/65 hover:border-white/30 hover:text-white")
            }
          >
            {sym}
          </button>
        ))}
      </div>
    </div>
  );
};
